import agent from "src/api/agent";

export const getAppSettings = () => agent.requests.get(`/Mobile/GetSetting`);

export const updateAppConfig = (data) => agent.requests.post(`/Admin/update-app-config`, data);
